import { __awaiter } from "tslib";
import * as libGeneralMeeting from '../domain/generalMeeting';
import * as libOrganization from '../domain/organization';
import * as libProposal from '../domain/proposal';
import { sourceToString } from '../domain/proposal';
export const VotePreferencesColumns = [
    { header: 'Organization title', key: 'organizationTitle', width: 20 },
    { header: 'Organization Issued Isins', key: 'organizationIssuedIsins', width: 20 },
    { header: 'Proposal title', key: 'proposalTitle', width: 20 },
    { header: 'Proposal identifier', key: 'proposalIdentifier', width: 20 },
    { header: 'Proposal source', key: 'proposalSource', width: 20 },
    { header: 'Poll title', key: 'pollTitle', width: 20 },
    { header: 'Poll classification tags', key: 'classificationTags', width: 20 },
    { header: 'Votes for', key: 'votesFor', width: 8 },
    { header: 'Votes against', key: 'votesAgainst', width: 11 },
    { header: 'Votes abstain', key: 'votesAbstain', width: 11 },
    { header: 'Votes no action', key: 'votesNoAction', width: 11 },
    { header: 'Votes withhold', key: 'votesWithhold', width: 11 },
    { header: 'Percentage for', key: 'percentageFor', width: 11 },
    { header: 'Percentage against', key: 'percentageAgainst', width: 15 },
    { header: 'Percentage abstain', key: 'percentageAbstain', width: 15 },
    { header: 'Manual Votes for', key: 'manualVotesFor', width: 15 },
    { header: 'Manual Votes against', key: 'manualVotesAgainst', width: 15 },
    { header: 'Manual Votes abstain', key: 'manualVotesAbstain', width: 15 },
    { header: 'Manual Votes no action', key: 'manualVotesNoAction', width: 15 },
    { header: 'Manual Votes withhold', key: 'manualVotesWithhold', width: 15 },
    { header: 'Auto Votes for', key: 'autoVotesFor', width: 15 },
    { header: 'Auto Votes against', key: 'autoVotesAgainst', width: 15 },
    { header: 'Auto Votes abstain', key: 'autoVotesAbstain', width: 15 },
    { header: 'Auto Votes no action', key: 'autoVotesNoAction', width: 15 },
    { header: 'Auto Votes withhold', key: 'autoVotesWithhold', width: 15 },
    { header: 'General meeting time', key: 'generalMeetingTime', width: 17 },
    { header: 'Export time', key: 'exportTime', width: 17 },
];
export const votePreferencesFromHabitats = (habitats, fetchAnonymizedVotePreferencesResponse) => {
    const votePreferencesSheets = habitats.map((h) => {
        const habitatVotePreferences = fetchAnonymizedVotePreferencesResponse.votePreferencesByHabitat[h.name];
        const data = pollVotePreferencesToVotePreferencesRows(habitatVotePreferences.pollVotePreferences, fetchAnonymizedVotePreferencesResponse.readTime, fetchAnonymizedVotePreferencesResponse.polls, fetchAnonymizedVotePreferencesResponse.proposals, fetchAnonymizedVotePreferencesResponse.generalMeetings, fetchAnonymizedVotePreferencesResponse.organizations);
        return {
            title: `V|${h.title}`,
            headers: VotePreferencesColumns,
            data,
        };
    });
    return votePreferencesSheets;
};
export const votePreferencesFromSchemes = (schemes, fetchAnonymizedVotePreferencesResponse) => {
    const votePreferencesSheets = schemes.map((s) => {
        const schemeVotePreferences = fetchAnonymizedVotePreferencesResponse.votePreferencesByScheme[s.name];
        const data = pollVotePreferencesToVotePreferencesRows(schemeVotePreferences.pollVotePreferences, fetchAnonymizedVotePreferencesResponse.readTime, fetchAnonymizedVotePreferencesResponse.polls, fetchAnonymizedVotePreferencesResponse.proposals, fetchAnonymizedVotePreferencesResponse.generalMeetings, fetchAnonymizedVotePreferencesResponse.organizations);
        return {
            title: `V|${s.title}`,
            headers: VotePreferencesColumns,
            data,
        };
    });
    return votePreferencesSheets;
};
export const votePreferencesFromFundVariants = (fundVariants, fetchAnonymizedVotePreferencesResponse, getPreferredLabel) => __awaiter(void 0, void 0, void 0, function* () {
    const votePreferencesSheets = yield Promise.all(fundVariants
        .sort((a, b) => a.name.localeCompare(b.name)) // Sort by FundVariant name for consistency
        .map((fv) => __awaiter(void 0, void 0, void 0, function* () {
        const fvVotePreferences = fetchAnonymizedVotePreferencesResponse.votePreferencesByFundVariant[fv.name];
        const data = pollVotePreferencesToVotePreferencesRows(fvVotePreferences.pollVotePreferences, fetchAnonymizedVotePreferencesResponse.readTime, fetchAnonymizedVotePreferencesResponse.polls, fetchAnonymizedVotePreferencesResponse.proposals, fetchAnonymizedVotePreferencesResponse.generalMeetings, fetchAnonymizedVotePreferencesResponse.organizations);
        const preferredLabel = yield getPreferredLabel(fv);
        return {
            title: `V|${preferredLabel.substring(-29)}`, // Restrict arbitrary label to 31 characters
            headers: VotePreferencesColumns,
            data,
        };
    })));
    return votePreferencesSheets;
});
export const summaryVotePreferencesSheet = (fetchAnonymizedVotePreferencesResponse) => {
    const data = pollVotePreferencesToVotePreferencesRows(fetchAnonymizedVotePreferencesResponse.summary, new Date(), fetchAnonymizedVotePreferencesResponse.polls, fetchAnonymizedVotePreferencesResponse.proposals, fetchAnonymizedVotePreferencesResponse.generalMeetings, fetchAnonymizedVotePreferencesResponse.organizations);
    const summaryVotePreferencesSheet = {
        title: 'V|Summary',
        headers: VotePreferencesColumns,
        data,
    };
    return summaryVotePreferencesSheet;
};
export const pollVotePreferencesToVotePreferencesRows = (pollVotePreferences, createTime, polls, proposals, generalMeetings, organizations) => {
    const getPVPDetails = (pvp) => {
        const poll = polls[pvp.pollName];
        const proposal = proposals[poll.proposalName];
        const { organizationID, generalMeetingID } = libProposal.nameToID(proposal.name);
        const generalMeeting = generalMeetings[libGeneralMeeting.IDToName({ organizationID, generalMeetingID })];
        const organization = organizations[libOrganization.IDToName({ organizationID })];
        return { poll, proposal, generalMeeting, organization };
    };
    return pollVotePreferences
        .sort((a, b) => {
        const { generalMeeting: gmA } = getPVPDetails(a);
        const { generalMeeting: gmB } = getPVPDetails(b);
        const dateA = gmA.meetingDate || new Date();
        const dateB = gmB.meetingDate || new Date();
        return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
    })
        .map((pvp) => {
        const { poll, proposal, organization, generalMeeting } = getPVPDetails(pvp);
        const row = {
            organizationTitle: organization.legalTitle,
            organizationIssuedIsins: organization.issuedIsins.join(','),
            proposalTitle: proposal.title,
            proposalIdentifier: proposal.sequenceIdentifier,
            proposalSource: sourceToString(proposal.source),
            pollTitle: poll.title,
            classificationTags: poll.classificationTags.map((t) => t.title).join('|'),
            votesTotal: pvp.votesTotal,
            votesFor: pvp.votesFor,
            votesAgainst: pvp.votesAgainst,
            votesAbstain: pvp.votesAbstain,
            votesNoAction: pvp.votesNoAction,
            votesWithhold: pvp.votesWithhold,
            percentageFor: pvp.votesFor / pvp.votesTotal,
            percentageAgainst: pvp.votesAgainst / pvp.votesTotal,
            percentageAbstain: pvp.votesAbstain / pvp.votesTotal,
            percentageNoAction: pvp.votesNoAction / pvp.votesTotal,
            percentageWithhold: pvp.votesWithhold / pvp.votesTotal,
            manualVotesFor: pvp.votesFor - pvp.autoVotesFor,
            manualVotesAgainst: pvp.votesAgainst - pvp.autoVotesAgainst,
            manualVotesAbstain: pvp.votesAbstain - pvp.autoVotesAbstain,
            manualVotesNoAction: pvp.votesNoAction - pvp.autoVotesNoAction,
            manualVotesWithhold: pvp.votesWithhold - pvp.autoVotesWithhold,
            autoVotesFor: pvp.autoVotesFor,
            autoVotesAgainst: pvp.autoVotesAgainst,
            autoVotesAbstain: pvp.autoVotesAbstain,
            autoVotesNoAction: pvp.autoVotesNoAction,
            autoVotesWithhold: pvp.autoVotesWithhold,
            generalMeetingTime: generalMeeting.meetingDate,
            exportTime: createTime,
        };
        return row;
    });
};
